import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      textAlign: "center",
    },
    linkButton: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.light,
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
      },
      justifyContent: "center",
      marginTop: theme.spacing(4),
      width: "50%",
      [theme.breakpoints.down("xs")]: {
        width: "100%",
      },
    },
  })
);
